import { useQuery } from '@apollo/client/react';
import { WhoAmI, type WhoAmIQuery } from '../../generated/graphql.api-app';
import { apolloClient } from '../apollo-client';

/** The signed-in player, as the game shows them. */
export interface Player {
  identityId: string;
  /** The display name, or "Player" when they have none. */
  name: string;
}

export const DEFAULT_PLAYER_NAME = 'Player';

export interface WhoAmIResult {
  /** The player; null when the API says there is no session; undefined until it has answered, or when skipped. */
  who: Player | null | undefined;
  error?: Error;
  loading: boolean;
}

export const toPlayer = (who: WhoAmIQuery['who']): Player | null =>
  who ? { identityId: who.identityId, name: who.displayName || DEFAULT_PLAYER_NAME } : null;

/** Who words-happen-gql says is signed in. `skip` it when there is no auth cookie: the answer would be null. */
export const useWhoAmIQuery = ({ skip = false }: { skip?: boolean } = {}): WhoAmIResult => {
  const { data, error, loading } = useQuery<WhoAmIQuery>(WhoAmI, { client: apolloClient, skip });

  return {
    who: data ? toPlayer(data.who) : undefined,
    error: error ?? undefined,
    loading,
  };
};
